import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ShoppingScreen } from '../features/shopping/ShoppingScreen.tsx';

export const Route = createFileRoute('/shopping')({
  validateSearch: z.object({
    from: z.iso.date().optional().catch(undefined),
    to: z.iso.date().optional().catch(undefined),
    /** Narrows the list to these recipes (shopping for some only). */
    recipes: z.array(z.uuid()).optional().catch(undefined),
  }),
  component: ShoppingRoute,
});

/** The default range from the shopping preferences, or `?from=&to=`; `?recipes=` filters. */
function ShoppingRoute() {
  const { from, to, recipes } = Route.useSearch();
  const range = from && to && from <= to ? { start: from, end: to } : undefined;
  return <ShoppingScreen range={range} recipes={recipes ?? []} />;
}
